export default __webpack_public_path__ + "static/media/9_1.e58634ec.jpg";